import {create} from "zustand";

const useBookingStore = create((set) => ({
    isBookingStatusUpdated: false,

    setBookingStatusUpdated: (status) => set({isBookingStatusUpdated: status}),
}));

export default useBookingStore